import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

const backgroundSx = {
  position: "absolute",
  zIndex: 10000100,
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  cursor: "progress"
};

const loaderSx = {
  position: "absolute",
  zIndex: 10000101,
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  width: "48px",
  height: "48px",
  borderRadius: "100%",
  padding: "6px",
  boxShadow: "0 0 10px -4px #00000069",
  backgroundColor: "background.paper",
  cursor: "progress"
};

const Loader = memo(({ fixed, style }) => {
  return (
    <>
      <Box sx={backgroundSx} />
      <Box style={style} sx={{ ...loaderSx, ...(fixed && { position: "fixed" }) }}>
        <CircularProgress size={36} thickness={4} />
      </Box>
    </>
  );
});

Loader.propTypes = {
  fixed: PropTypes.bool
};

Loader.defaultProps = {
  fixed: false
};

export default Loader;
